/* eslint-disable react/prop-types */
// added the above text for the sonarqube fix

import { useSelector } from "react-redux";

import {
    Backdrop,
    CommonPopupCrud,
    LoadingWipeText
} from "@common";

import CustomAiPrompt from "@common/CustomAiPrompt";
// ==============================================================================================================
function GeneratePrompt({ onModelChange, onCustomPromptChange, ...props }) {
  const { genloading, webSocketMessage } =
    useSelector((state) => ({
      ...state.features,
    }));
  return (
    <CommonPopupCrud
      largeScreen={true}
      heading={props?.heading}
      close={() => props?.close()}
      hideSaveAndNext={true}
      handleSubmit={props?.handleFunction}
      saveText="Proceed"
      buttonAlignRight={true}
      alertSaveColor={true}
      loading={genloading}
    >
      <CustomAiPrompt onModelChange={onModelChange}
        onCustomPromptChange={onCustomPromptChange} />
      {genloading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={genloading}
        >
          {/* <CircularProgress color="inherit" /> */}
          <LoadingWipeText>{webSocketMessage}</LoadingWipeText>
        </Backdrop>
      )}
    </CommonPopupCrud>
  );
}

export default GeneratePrompt;
